import { render, staticRenderFns } from "./BigEventStorming.vue?vue&type=template&id=ca486000&xmlns%3Av-on=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml&"
import script from "./BigEventStorming.vue?vue&type=script&lang=js&"
export * from "./BigEventStorming.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports